<template>
  <b-tab active>
    <template #title>
      <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50" />
      <span class="d-none d-sm-inline">{{ $t('Information') }}</span>
    </template>
    <div>

      <!-- Header: Personal Info -->
      <div class="d-flex">
        <feather-icon icon="UserIcon" size="19" />
        <h4 class="mb-0 ml-50">
          {{ $t('General Information') }}
        </h4>
      </div>

      <!-- User Info: Input Fields -->
      <b-form class="mt-2">
        <b-row>
          <b-col cols="12" md="6">
            <b-form-group :label="$t('Photo')" label-for="photo">
              <photo v-model="driverData.photo" />
              <small v-if="errors && ('photo' in errors)" class="text-danger">
                {{ $t(errors['photo'][0]) }}
              </small>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>

          <!-- Field: name -->
          <b-col cols="12" md="6">
            <b-form-group :label="$t('Name')" label-for="username">
              <b-form-input id="username" v-model="driverData.name" :state="null" />
              <small v-if="errors && ('name' in errors)" class="text-danger">
                {{ $t(errors['name'][0]) }}
              </small>
            </b-form-group>
          </b-col>


          <!-- Field: uniqueid -->
          <b-col cols="12" md="6">
            <b-form-group :label="$t('driver uniqueid')" label-for="email">
              <b-form-input id="uniqueid" v-model="driverData.uniqueId" :state="null" />
              <small v-if="errors && ('uniqueid' in errors)" class="text-danger">
                {{ $t(errors['uniqueid'][0]) }}
              </small>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-group :label="$t('mobile number')" label-for="mobileNumber">
              <b-form-input id="mobileNumber" v-model="driverData.mobileNumber" :state="null" />
              <small v-if="errors && ('mobileNumber' in errors)" class="text-danger">
                {{ $t(errors['mobileNumber'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <!-- Field: owner -->
          <b-col cols="12" md="6">
            <b-form-group :label="$t('Owner')" label-for="driver-owner">
              <v-select v-model="driverData.owner_id" :options="onwerOptions" :reduce="o => o.id"
                :getOptionLabel="o => o.name" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :clearable="false" input-id="driver-owner" />
              <small v-if="errors && ('ownerid' in errors)" class="text-danger">
                {{ $t(errors['ownerid'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <!-- Header: Wasl Info -->
          <b-col cols="12" md="12" v-if="$store.state.auth.userData.roles.includes(this.$roles.SUPER_ADMIN)">
            <b-form-group :label="$t('Wasl Key')" label-for="referenceKey">
              <b-form-input id="referenceKey" v-model="driverData.referenceKey"
                :state="errors && ('referenceKey' in errors) ? false : null" />
              <small v-if="errors && ('referenceKey' in errors)" class="text-danger">
                {{ $t(errors['referenceKey'][0]) }}
              </small>
            </b-form-group>
          </b-col>

        </b-row>

      </b-form>

    </div>
    <b-button v-if="driverData" type="submit" variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1"
      :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="()=> $emit('onSubmit')">
      {{ $t('Save Changes') }}
    </b-button>
  </b-tab>

</template>

<script>
import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
  BTab,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import flatPickr from 'vue-flatpickr-component'
import Photo from '@/views/modules/Utils/Photo.vue'
import store from '@/store'

export default {
  components: {
    BTab,
    flatPickr,
    BButton,
    BMedia,
    BAvatar,
    BRow,
    OrbitSpinner,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    vSelect,
    Photo
  },
  emits:['onSubmit'],
  props: {
    driverData: {
      type: Object,
      required: true,
    },

    errors: {
      type: Object,
      required: true
    }

  },
  setup() {

    const onwerOptions = ref([])

    store.dispatch('app_driver/getOwners')
      .then(res => onwerOptions.value = [...res.data])
      .catch(reason => { })

    return {
      onwerOptions,
      avatarText,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
